import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { AuthClient } from './auth.client';
import { AuthService } from './auth.service';
import { AuthStore } from './store/auth.store';

export const provideAuth = (): Provider[] | EnvironmentProviders[] => {
  return [
    provideEnvironmentInitializer(() => inject(AuthClient)),
    provideEnvironmentInitializer(() => inject(AuthStore)),
    provideEnvironmentInitializer(() => inject(AuthService)),
  ];
};
